export class CustomTable {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Custom Table";
    this.scene = "Custom Table";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    options.table.forEach((element, index) => {
      let row = index + 1;
      this.data.push({
        name: "Position " + row,
        value: { text: element?.position },
      });
      this.data.push({
        name: "Indicator " + row,
        value: { text: element?.indicator },
      });
      this.data.push({
        name: "Team " + row,
        value: { text: element?.team },
      });
      this.data.push({
        name: "Column One, Row " + row,
        value: { text: element?.Column1 },
      });
      this.data.push({
        name: "Column Two, Row " + row,
        value: { text: element?.Column2 },
      });
      this.data.push({
        name: "Column Three, Row " + row,
        value: { text: element?.Column3 },
      });
      this.data.push({
        name: "Column Four, Row " + row,
        value: { text: element?.Column4 },
      });
      this.data.push({
        name: "Badge_" + row,
        value: { image: element?.badge },
      });
      this.data.push({
        name: "Highlight " + row,
        value: { text: element?.highlight },
      });
    });
    this.data.push({
      name: "Header Position",
      value: { text: options?.headers?.position },
    });
    this.data.push({
      name: "Header Indicator",
      value: { text: options?.headers?.indicator },
    });
    this.data.push({
      name: "Header Team",
      value: { text: options?.headers?.team },
    });
    this.data.push({
      name: "Header Column One",
      value: { text: options?.headers?.Column1 },
    });
    this.data.push({
      name: "Header Column Two",
      value: { text: options?.headers?.Column2 },
    });
    this.data.push({
      name: "Header Column Three",
      value: { text: options?.headers?.Column3 },
    });
    this.data.push({
      name: "Header Column Four",
      value: { text: options?.headers?.Column4 },
    });
    this.data.push({
      name: "Column Style Position",
      value: { text: options?.columnStyles?.position },
    });
    this.data.push({
      name: "Column Style Indicator",
      value: { text: options?.columnStyles?.indicator },
    });
    this.data.push({
      name: "Column Style Team",
      value: { text: options?.columnStyles?.team },
    });
    this.data.push({
      name: "Column Style Column One",
      value: { text: options?.columnStyles?.Column1 },
    });
    this.data.push({
      name: "Column Style Column Two",
      value: { text: options?.columnStyles?.Column2 },
    });
    this.data.push({
      name: "Column Style Column Three",
      value: { text: options?.columnStyles?.Column3 },
    });
    this.data.push({
      name: "Column Style Column Four",
      value: { text: options?.columnStyles?.Column4 },
    });
    this.data.push({
      name: "Title",
      value: { text: options?.title },
    });
    this.data.push({
      name: "Subtitle",
      value: { text: options?.subtitle },
    });
        this.data.push({
      name: "Column Active Position",
      value: { text: options?.activeColumns?.position },
    });
    this.data.push({
      name: "Column Active Indicator",
      value: { text: options?.activeColumns?.indicator },
    });
   this.data.push({
      name: "Column Active Badge",
      value: { text: options?.activeColumns?.badge },
    });
    this.data.push({
      name: "Column Active Team",
      value: { text: options?.activeColumns?.team },
    });
    this.data.push({
      name: "Column Active Column One",
      value: { text: options?.activeColumns?.Column1 },
    });
    this.data.push({
      name: "Column Active Column Two",
      value: { text: options?.activeColumns?.Column2 },
    });
    this.data.push({
      name: "Column Active Column Three",
      value: { text: options?.activeColumns?.Column3 },
    });
    this.data.push({
      name: "Column Active Column Four",
      value: { text: options?.activeColumns?.Column4 },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
